module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8023.d0fd7b16.png";